module.exports = __webpack_public_path__ + "static/media/item3.8550ffca.jpg";